import type { PreloadedQuery } from 'react-relay';
import type { RouteResource } from '@atlassian/react-resource-router';
import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import QUERY, {
	type JiraSpaPageContainerQuery,
} from '@atlassian/jira-page-container-v2/src/common/ui/page-container/__generated__/JiraSpaPageContainerQuery.graphql';

export const jiraSpaPageContainerResource: RouteResource<
	PreloadedQuery<JiraSpaPageContainerQuery>
> = createRelayResource<JiraSpaPageContainerQuery>({
	type: 'JIRA_SPA_STATE_RELAY',
	getQuery: (_, { tenantContext: { cloudId } }) => {
		return {
			parameters: QUERY,
			variables: {
				cloudId,
			},
			options: { fetchPolicy: 'store-and-network' as const },
		};
	},
	captureErrors: true,
	isCritical: true,
});
